import { useRef, useState } from "react";
import { Coins, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { VideoViewers } from "@/components/VideoViewers";
import { flyCoins, playCoin } from "@/lib/celebrate";

export function FeedVideo({ p }) {
  const { user, refreshUser } = useAuth();
  const [done, setDone] = useState(p.video_rewarded);
  const watched = useRef(0), last = useRef(null), started = useRef(false), box = useRef(null);
  const eligible = !!user && user.user_id !== p.user_id && !!p.video_duration;

  const onPlay = (e) => {
    last.current = e.target.currentTime;
    if (eligible && !done && !started.current) { started.current = true; api.post(`/feed/posts/${p.id}/video-start`).catch(() => {}); }
  };
  const onTime = (e) => {
    const t = e.target.currentTime, d = t - (last.current ?? t);
    if (d > 0 && d < 1.5) watched.current += d;
    last.current = t;
  };
  const onEnded = async (e) => {
    started.current = false;
    if (!eligible || done) return;
    if (watched.current < e.target.duration - 1.5) { toast("Fast geschafft! Schau das Video ohne Vorspulen bis zum Ende für +5 Punkte 🎬"); watched.current = 0; return; }
    try {
      const { data } = await api.post(`/feed/posts/${p.id}/video-complete`);
      setDone(true);
      if (data.points) { toast.success(`Video komplett geschaut! +${data.points} Punkte 🎉`); flyCoins({ from: box.current }); playCoin(); refreshUser(); window.dispatchEvent(new Event("points-changed")); }
    } catch (err) { toast.error(formatErr(err)); }
    watched.current = 0;
  };

  return (
    <div ref={box} className="relative">
      <video src={`${process.env.REACT_APP_BACKEND_URL}${p.video_file}${p.video_poster ? "" : "#t=0.5"}`} poster={p.video_poster ? `${process.env.REACT_APP_BACKEND_URL}${p.video_poster}` : undefined} controls playsInline preload="metadata" controlsList="nodownload noplaybackrate"
        onPlay={onPlay} onTimeUpdate={onTime} onSeeking={(e) => { last.current = e.target.currentTime; }} onEnded={onEnded}
        data-testid={`post-video-${p.id}`} className="w-full max-h-[32rem] rounded-2xl bg-slate-900" />
      {eligible && (
        <span data-testid={`post-video-points-${p.id}`} className={`absolute top-2 left-2 inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-extrabold shadow ${done ? "bg-emerald-500 text-white" : "bg-amber-300 text-amber-900"}`}>
          {done ? <><CheckCircle2 className="w-3.5 h-3.5" /> Punkte erhalten</> : <><Coins className="w-3.5 h-3.5" /> +5 Punkte bis zum Ende</>}
        </span>
      )}
      {user?.role === "admin" && <VideoViewers postId={p.id} />}
    </div>
  );
}
